export interface ChannelItem {
  id: string;
  icon: string;
  index: string;
  name: string;
  summary: string;
  points: string[];
}

export interface RankingItem {
  rank: number;
  title: string;
  summary: string;
  tag: string;
  heat: string;
  delta: string;
}

export interface ProcessStep {
  title: string;
  desc: string;
}

export interface PrivacyPoint {
  icon: string;
  title: string;
  desc: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface StatItem {
  value: string;
  label: string;
}

export const channels: ChannelItem[] = [
  {
    id: "private-message",
    icon: "ri-chat-private-line",
    index: "01",
    name: "私信投稿",
    summary: "通过站内私信直接联系审核组，适合携带截图与短线索的快速沟通，对话内容仅双方可见。",
    points: ["支持图片与截图附件", "对话可随时撤回", "通常 30 分钟内首次响应"],
  },
  {
    id: "email",
    icon: "ri-mail-send-line",
    index: "02",
    name: "邮箱投稿",
    summary: "黑料投稿联系方式中最适合长文与多附件的一种，收件地址加密，仅审核组可读，适合整理完整的线索。",
    points: ["支持较大体积附件", "可使用一次性匿名邮箱", "建议标题注明时间与地点"],
  },
  {
    id: "form",
    icon: "ri-file-shield-2-line",
    index: "03",
    name: "在线表单投稿",
    summary: "无需注册即可填写的匿名投稿渠道，提交完成后系统会生成随机查询码，方便后续核对进度。",
    points: ["全程无需账号与实名", "自动生成随机查询码", "支持纯文字与链接线索"],
  },
];

export const rankingTabs = [
  { id: "week", label: "本周热度" },
  { id: "month", label: "本月热度" },
  { id: "all", label: "长线关注" },
];

export const rankingData: Record<string, RankingItem[]> = {
  week: [
    {
      rank: 1,
      title: "消费维权类线索",
      summary: "本周新增投稿上升明显，多附带票据、订单截图与聊天记录。",
      tag: "热度上升",
      heat: "9.8 万",
      delta: "+38%",
    },
    {
      rank: 2,
      title: "职场权益类线索",
      summary: "集中在离职结算与加班记录，证据链相对完整，核验速度较快。",
      tag: "核验中",
      heat: "7.4 万",
      delta: "+21%",
    },
    {
      rank: 3,
      title: "食品安全类线索",
      summary: "后厨流程与供应链记录成为主要素材，图文比例高于上月。",
      tag: "新增",
      heat: "6.1 万",
      delta: "+17%",
    },
    {
      rank: 4,
      title: "平台规则类线索",
      summary: "关于费用扣除与账号限制的咨询量稳定，多需要补充时间线。",
      tag: "稳定",
      heat: "4.9 万",
      delta: "+6%",
    },
    {
      rank: 5,
      title: "合同纠纷类线索",
      summary: "合同扫描件与邮件往来是最常见附件，建议一并打包发送。",
      tag: "待补充",
      heat: "3.6 万",
      delta: "+3%",
    },
  ],
  month: [
    {
      rank: 1,
      title: "职场权益类线索",
      summary: "本月累计投稿量居首，集中在薪酬结算与考勤争议方向。",
      tag: "本月首位",
      heat: "32.5 万",
      delta: "+44%",
    },
    {
      rank: 2,
      title: "消费维权类线索",
      summary: "退款与售后争议持续走高，附带的电子凭证质量明显提升。",
      tag: "热度上升",
      heat: "28.1 万",
      delta: "+29%",
    },
    {
      rank: 3,
      title: "合同纠纷类线索",
      summary: "多涉及服务协议的履行细节，长文投稿占比高于以往。",
      tag: "核验中",
      heat: "21.7 万",
      delta: "+18%",
    },
    {
      rank: 4,
      title: "食品安全类线索",
      summary: "围绕原料来源与操作流程的投稿增多，图文记录较完整。",
      tag: "稳定",
      heat: "18.3 万",
      delta: "+11%",
    },
    {
      rank: 5,
      title: "平台规则类线索",
      summary: "账号权限与费用争议保持平稳，多为可复现的操作记录。",
      tag: "稳定",
      heat: "15.2 万",
      delta: "+7%",
    },
  ],
  all: [
    {
      rank: 1,
      title: "消费维权类线索",
      summary: "长期占据关注首位，投稿人多愿意提供完整购买与沟通记录。",
      tag: "长期关注",
      heat: "186 万",
      delta: "+12%",
    },
    {
      rank: 2,
      title: "职场权益类线索",
      summary: "历久不衰的投稿方向，材料规范度逐年提升，便于交叉核验。",
      tag: "长期关注",
      heat: "164 万",
      delta: "+9%",
    },
    {
      rank: 3,
      title: "食品安全类线索",
      summary: "与日常生活高度相关，图文类投稿占比长期保持在前列。",
      tag: "长期关注",
      heat: "141 万",
      delta: "+8%",
    },
    {
      rank: 4,
      title: "合同纠纷类线索",
      summary: "多需要配合文件核对，处理周期相对更长但完成度较高。",
      tag: "稳定",
      heat: "118 万",
      delta: "+5%",
    },
    {
      rank: 5,
      title: "平台规则类线索",
      summary: "随平台迭代出现新的争议点，投稿总量保持缓慢增长。",
      tag: "稳定",
      heat: "96 万",
      delta: "+4%",
    },
  ],
};

export const processSteps: ProcessStep[] = [
  {
    title: "匿名提交",
    desc: "通过私信、邮箱或在线表单发送线索，全程不要求填写真实身份信息。",
  },
  {
    title: "登记编号",
    desc: "审核组收到后完成分类与编号，并生成一个唯一的随机查询码。",
  },
  {
    title: "交叉核验",
    desc: "对可验证的部分进行比对，必要时通过原渠道联系补充材料。",
  },
  {
    title: "处理反馈",
    desc: "通过原渠道或查询码反馈结果，未采用的材料按隐私承诺处理。",
  },
];

export const privacyPoints: PrivacyPoint[] = [
  {
    icon: "ri-user-forbid-line",
    title: "不强制实名",
    desc: "投稿全程无需身份证件或真实姓名，匿名投稿渠道默认关闭身份采集。",
  },
  {
    icon: "ri-lock-2-line",
    title: "加密存储",
    desc: "所有材料加密保存，仅审核组最小范围内可访问，访问记录可追溯。",
  },
  {
    icon: "ri-delete-back-2-line",
    title: "可随时撤回",
    desc: "在材料进入最终处理前，均可凭查询码或原渠道申请撤回并删除。",
  },
  {
    icon: "ri-eye-off-line",
    title: "不留痕",
    desc: "不记录可用于对外识别的身份信息，提交痕迹仅用于内部进度核对。",
  },
];

export const stats: StatItem[] = [
  { value: "30 分钟", label: "平均首次响应" },
  { value: "3 种", label: "可用匿名入口" },
  { value: "100%", label: "支持完全匿名" },
  { value: "7×24", label: "全天候受理" },
];

export const faqs: FaqItem[] = [
  {
    q: "黑料投稿需要实名吗？",
    a: "不需要。黑料投稿匿名入口支持完全匿名提交，您无需注册账号或提供真实身份信息，只需从私信、邮箱或在线表单中任选一种匿名投稿渠道即可。",
  },
  {
    q: "目前有哪些黑料投稿联系方式？",
    a: "当前提供三种方式：站内私信、加密邮箱以及在线表单。三种渠道的适用场景与附件建议已在本页的投稿方式区域逐一说明，您可以根据线索长短自行选择。",
  },
  {
    q: "提交后如何知道处理进度？",
    a: "提交成功后系统会生成一个随机查询码。您可以凭查询码随时核对处理状态，整个过程无需再次暴露身份，也不会留下可用于识别的信息。",
  },
  {
    q: "我提供的信息会被公开吗？",
    a: "不会。所有材料仅用于内部审核与交叉核验，未经投稿人同意，不会公开任何可能识别来源身份的信息。",
  },
  {
    q: "可以撤回已经提交的投稿吗？",
    a: "可以。在材料进入最终处理前，您都可以通过原提交渠道或随机查询码申请撤回，我们会在核实后删除对应内容并反馈结果。",
  },
  {
    q: "哪些内容不予受理？",
    a: "涉及明显人身攻击、未经核实的他人私人隐私，以及违反法律法规的内容，均不予受理。我们更希望收到可核验、有依据的线索。",
  },
];